import { Typography } from "@mui/material";
import { useState } from "react";
import { useContent } from "../content/useContent";

type IProps = {
  text: any;
};

const ReadMore: React.FC<IProps> = ({ text }) => {
  const { general } = useContent();
  const splitAt = (index: any, xs: any) => [
    xs.slice(0, index),
    xs.slice(index),
  ];
  const [hide, setHide] = useState(true);

  if (!text) return <></>;
  return (
    <Typography component="p" variant="body1">
      {text.length < 200 ? (
        text
      ) : (
        <>
          {splitAt(100, text)[0]}...{" "}
          {hide ? (
            <Typography
              component="p"
              color="primary"
              variant="body1"
              sx={{ cursor: "pointer", display: "inline-block" }}
              onClick={(e: any) => {
                e.stopPropagation();
                setHide(false);
              }}
            >
              {general.showMore}
            </Typography>
          ) : (
            <>
              {splitAt(100, text)[1]}{" "}
              <Typography
                component="p"
                color="primary"
                variant="body1"
                sx={{ cursor: "pointer", display: "inline-block" }}
                onClick={(e: any) => {
                  e.stopPropagation();
                  setHide(true);
                }}
              >
                {general.showLess}
              </Typography>
            </>
          )}
        </>
      )}
    </Typography>
  );
};

export default ReadMore;
